var map = {
	"./aztecs-DE.png": "8e76",
	"./bengalis-DE.png": "383b",
	"./berbers-DE.png": "1e1b",
	"./bohemians-DE.png": "be4e",
	"./britons-DE.png": "802a",
	"./bulgarians-DE.png": "77d5",
	"./burgundians-DE.png": "b696",
	"./burmese-DE.png": "c63d",
	"./byzantines-DE.png": "ae81",
	"./celts-DE.png": "c5a8",
	"./chinese-DE.png": "5507",
	"./cumans-DE.png": "7ecb",
	"./dravidians-DE.png": "0aac",
	"./ethiopians-DE.png": "6011",
	"./franks-DE.png": "418b",
	"./goths-DE.png": "db1f",
	"./gurjaras-DE.png": "2d5d",
	"./huns-DE.png": "a735",
	"./incas-DE.png": "e62a",
	"./indians-DE.png": "e07b",
	"./italians-DE.png": "e8db",
	"./japanese-DE.png": "d417",
	"./khmer-DE.png": "da13",
	"./koreans-DE.png": "6037",
	"./lithuanians-DE.png": "8988",
	"./magyars-DE.png": "d437",
	"./malay-DE.png": "6fd8",
	"./malians-DE.png": "5e1c",
	"./mayans-DE.png": "8a23",
	"./mongols-DE.png": "26f1",
	"./persians-DE.png": "077e",
	"./poles-DE.png": "ba84",
	"./portuguese-DE.png": "c8ad",
	"./saracens-DE.png": "5274",
	"./sicilians-DE.png": "1806",
	"./slavs-DE.png": "2f59",
	"./spanish-DE.png": "1943",
	"./tatars-DE.png": "9db2",
	"./teutons-DE.png": "9132",
	"./turks-DE.png": "6304",
	"./vietnamese-DE.png": "6184",
	"./vikings-DE.png": "ec5a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "02a3";